<script>
import { Line, mixins } from "vue-chartjs";
const { reactiveProp } = mixins

export default {
  extends: Line,
  mixins: [reactiveProp],
  
  data() {
    return {
    };
  },

  props: ['chartData', 'chartoptions'],

  mounted() {
    this.renderChart(this.chartData, this.chartoptions)
  }
};
</script>
